import { ImageController } from '@/commons/assetsManager/ImageController';

class ImageLoaderManager {
    imagesContainer: ImageController[] = [];
    private static _instance: ImageLoaderManager;

    static loadImage(imageUrl: string): Promise<Error | HTMLImageElement> {
        if (!imageUrl) {
            return Promise.reject(new Error('No image URL provided'));
        }

        if (ImageLoaderManager.isImageLoaded(imageUrl)) {
            return ImageLoaderManager.instance.imagesContainer.find((image) => image.imageUrl === imageUrl)!.getImage();
        }
        const image = new ImageController(imageUrl);
        ImageLoaderManager.instance.imagesContainer.push(image);
        return image.getImage();
    }

    static isImageLoaded(imageUrl: string): boolean {
        return ImageLoaderManager.instance.imagesContainer.some((image) => image.imageUrl === imageUrl);
    }

    private static get instance(): ImageLoaderManager {
        if (!ImageLoaderManager._instance) {
            ImageLoaderManager._instance = new ImageLoaderManager();
        }
        return ImageLoaderManager._instance;
    }
}

export { ImageLoaderManager };
